import myAxios from "@/utils/request";
export default {
  // 消息提醒
  // 列表
  getNotificationList(params) {
    return myAxios.post("/api/message/getmessagebyselect", params);
  },
  batchNotificationDelete(params) {
    return myAxios.post("/api/message/backbatchdelete", params);
  },
  // 添加/修改
  addNotification(params) {
    return myAxios.post("/api/message/addmessagebymodel", params);
  },
  // 获取消息提醒详细信息
  getNotificationInfo(params) {
    const { id } = params;
    return myAxios.get("/api/message/getmessagequeuebyid?id=" + id);
  }
};
